import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Space, Spin, Typography } from 'antd';
import { kedoGet } from './kedoApi';

const { Text } = Typography;

const KedoDashboardPage = () => {
    const [stats, setStats] = useState(null);
    const [org, setOrg] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const [dash, me] = await Promise.all([
                    kedoGet('/dashboard'),
                    kedoGet('/organizations/current')
                ]);
                if (cancelled) return;
                setStats(dash);
                setOrg(me);
            } catch (e) {
                if (!cancelled) {
                    setError(
                        e?.response?.data?.message ||
                            e.message ||
                            'Не удалось загрузить кабинет Kedo'
                    );
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: 80 }}>
                <Spin size="large" />
            </div>
        );
    }

    if (error) {
        return <Alert type="error" message={error} showIcon />;
    }

    const cards = [
        {
            key: 'to_sign',
            label: 'На подпись',
            value: stats?.to_sign ?? 0,
            className: 'warn',
            to: '/kedo/app/documents?filter=to_sign'
        },
        {
            key: 'to_approve',
            label: 'На согласование',
            value: stats?.to_approve ?? 0,
            to: '/kedo/app/documents?filter=to_approve'
        },
        {
            key: 'incoming',
            label: 'Входящие',
            value: stats?.incoming ?? 0,
            to: '/kedo/app/documents?direction=incoming'
        },
        {
            key: 'outgoing',
            label: 'Исходящие',
            value: stats?.outgoing ?? 0,
            to: '/kedo/app/documents?direction=outgoing'
        },
        {
            key: 'overdue',
            label: 'Просрочено',
            value: stats?.overdue ?? 0,
            className: 'warn',
            to: '/kedo/app/documents?filter=overdue'
        },
        {
            key: 'signed',
            label: 'Подписано',
            value: stats?.signed ?? 0,
            className: 'ok',
            to: '/kedo/app/documents?status=signed'
        }
    ];

    return (
        <>
            <section className="kedo-hero">
                <div>
                    <h1>Рабочий стол ЭДО</h1>
                    <p>
                        Кабинет организации для внутреннего КЭДО и обмена
                        документами. Интеграции — только через API.
                    </p>
                    <Space style={{ marginTop: 18 }} wrap>
                        <Button type="primary" href="/kedo/app/documents">
                            Все документы
                        </Button>
                        <Button href="/kedo/app/documents?new=1">
                            Создать документ
                        </Button>
                        <Button href="/kedo/app/settings">Провайдеры и ключи</Button>
                    </Space>
                </div>
                <div className="kedo-hero-panel">
                    <Text type="secondary">Организация</Text>
                    <div style={{ fontSize: 22, fontFamily: 'Georgia, serif', marginTop: 6 }}>
                        {org?.organization?.name || '—'}
                    </div>
                    <div style={{ marginTop: 8, opacity: 0.75, fontSize: 13 }}>
                        ИНН {org?.organization?.inn || 'не указан'} · роль{' '}
                        {org?.member?.role || '—'} ·{' '}
                        {org?.authType === 'api_key' ? 'API-ключ' : 'JWT'}
                    </div>
                </div>
            </section>

            <div className="kedo-stat-grid">
                {cards.map(c => (
                    <Link
                        key={c.key}
                        to={c.to}
                        className={`kedo-stat ${c.className || ''}`}
                        style={{ color: 'inherit', textDecoration: 'none' }}
                    >
                        <div className="label">{c.label}</div>
                        <div className="value">{c.value}</div>
                    </Link>
                ))}
            </div>

            <div className="kedo-panel">
                <h2>Быстрый старт</h2>
                <ol style={{ margin: 0, paddingLeft: 18, lineHeight: 1.7 }}>
                    <li>
                        Настройте SMS / Госключ / шифрование в{' '}
                        <Link to="/kedo/app/settings">Настройках</Link>.
                    </li>
                    <li>
                        Выпустите API-ключ для внешних систем и укажите webhook{' '}
                        <code>document.signed</code>.
                    </li>
                    <li>
                        Создайте документ с <code>external_refs</code> (ссылки на
                        внешние ID) — без чужих FK.
                    </li>
                    <li>
                        OpenAPI:{' '}
                        <a href="/api/kedo/v1/docs" target="_blank" rel="noreferrer">
                            /api/kedo/v1/docs
                        </a>
                    </li>
                </ol>
            </div>
        </>
    );
};

export default KedoDashboardPage;
